<template>
  <div class="market-CCR-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch">
       <el-button slot="btn" @click="onExport" :loading="exportLoading">导出</el-button>
    </Search>
    <div class="fun-btn-box">
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #name="{ row }">{{ row.name }}</template>
      <template #storeName="{ row }">{{ row.storeName }}</template>
      <template #mallName="{ row }">{{ row.mallName }}</template>
      <template #skuName="{ row }">{{ row.skuName ?  row.skuName : '---' }}</template>
      <template #phone="{ row, scope }">
        <span :key="tableKey">{{ row.phone_show || row.phone }}</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.phone" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index)">
            {{ row.phone_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
      <template #discountAmount="{ row }">{{ row.discountAmount }}</template>
      <template #orderAmount="{ row }">{{ row.orderAmount }}</template>
      <template #paymentOrderId="{ row }">{{ row.paymentOrderId }}</template>
      <template #usedTime="{ row }">{{ row.usedTime ? $moment(row.usedTime).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #code="{ row }">{{ row.code?row.code:'---' }}</template>
      <template #source="{ row }">{{ row.source }}</template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import aes from '@/common/aes.js'
import { downFile } from "@/utils";
import { api_getDeductCouponUsedPage, api_getDeductCouponUsedExport} from '@/api/market'
import { api_getUserPhone } from '@/api/common'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
export default {
  name: "mcheckIndex",
  mixins: [ tableList ],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    const startDate = this.$moment().subtract(30, 'days').valueOf() //默认开始时间
    const endDate = this.$moment().subtract(0, 'days').valueOf() //默认结束时间
    return {
      renderData: [
        {
          label: "核销时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "time",
          valueFormat: 'timestamp'
        },
        {
          label: "商品名称",
          placeholder: "请输入商品名称",
          type: "input",
          key: "skuName",
        },
        {
          label: "抵扣券名称",
          placeholder: "请输入抵扣券名称",
          type: "input",
          key: "name",
        },
        {
          label: "交易订单号",
          placeholder: "请输入交易订单号",
          type: "input",
          key: "paymentOrderId",
        },
        {
          label: "商场名称",
          type: "mall",
          key: "mallIds",
        },
        {
          label: "来源",
          type: "select",
          key: "source",
          option: [
            {label: '微信小程序', value: 'WechatMiniapp'},
            {label: '支付宝小程序', value: 'AlipayMiniapp'},
          ]
        },
      ],
      form: {
        time:[startDate,endDate]
      },
      tableKey: false,
      exportLoading: false,
      tableThData: [
        { prop: "name", label: "抵扣券名称", minWidth: "180", },
        { prop: "skuName", label: "商品名称", minWidth: "180", },
        { prop: "mallName", label: "商场名称", minWidth: "180", },
        { prop: "phone", label: "会员手机号", minWidth: "160", },
        { prop: "code", label: "券码", minWidth: "180", },
        { prop: "discountAmount", label: "核销金额", minWidth: "120", },
        { prop: "orderAmount", label: "订单金额", minWidth: "120", },
        { prop: "paymentOrderId", label: "交易订单号", minWidth: "160", },
        { prop: "usedTime", label: "核销时间", minWidth: "280", },
        { prop: "source", label: "来源", minWidth: "120", },
      ],

    };
  },
  created () {
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      let params = {
        ...this.form,
        productType:'DeductCoupon',
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      params.usedTimeFrom = this.form.time ? this.form.time[0] : ''
      params.usedTimeTo = this.form.time ? this.form.time[1] : ''
      delete params.time
      const data = await api_getDeductCouponUsedPage(params)
      console.log('data: ', data);
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },

    // 点击查看手机号
    async onLookPhone(row, index) {
      try {
        if (row.phone_show) {
          delete this.tableTrData[index].phone_show
        } else {
          const {phone} = await api_getUserPhone({id: row.userId})
          this.tableTrData[index].phone_show = aes.decrypt(phone)
        }
        this.tableKey = !this.tableKey
      } catch (error) {}
    },
   // 导出
    async onExport() {
      this.exportLoading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
        productType:'DeductCoupon'
      }
      params.usedTimeFrom = this.form.time ? this.form.time[0] : undefined
      params.usedTimeTo = this.form.time ? this.form.time[1] : undefined
      delete params.time
      delete params.statusList
      let res = await api_getDeductCouponUsedExport(params)
      downFile(res)
      this.exportLoading = false
    },
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-CCR-index {
  width: 100%;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
  }

  .look-phone-btn {
    font-size: 10px;
    color: #3775FF;
    margin-left: 5px;
  }

  .del {
    color: #F74A4A;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }
  .dot-success{
    background: #05c8af;
  }

  .dot-clear {
    background: #F74A4A;
  }

  .dot-ing {
    background: #3775FF;
  }

  .dot-new {
    background: #ccc;
  }
}
</style>
